import { connect } from "react-redux";
import { compose } from "recompose";

import { withMessenger } from "src/modules/messenger/Provider/MessengerProvider";
import { getStatus, getPresence } from "src/duck/selectors";

import { getXmppLogin } from "src/modules/auth/duck/selectors";

import App from "./App";

function mapStateToProps(state) {
  return {
    presence: getPresence(state),
    status: getStatus(state),
    xmppLogin: getXmppLogin(state)
  };
}

const enhance = compose(connect(mapStateToProps), withMessenger);

export default enhance(App);
